import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import dayjs from "dayjs";
//import axios from 'axios';
import { API_GET, API_POST } from "../../services/api.service";
import { Link } from "react-router-dom";
//import Button from "components/CustomButtons/Button.jsx";
import { Button, ButtonGroup } from "@material-ui/core";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";

import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import ViewHeadlineIcon from '@material-ui/icons/ViewHeadline';
import InfoBox from "../../components/InfoIcon/InfoIcon";


const { REACT_APP_SERVER_URL } = process.env;

function FilesList(props) {
  const { user, cid, campaignsDetails } = props;
  const [data, setData] = useState({});
  const [page, setPage] = useState(1);

  const countPerPage = 10;

  const StartProcess = async (row) => {
    let data = {
      filePath: row.ServerPath,
    };
    let fileupload = await API_POST(`action/uploadFileHeaders`, data);
    if (fileupload.success && fileupload.data && fileupload.data.headers && fileupload.data.headers.length > 0) {
      let obj = {
        headers: fileupload.data.headers[0].data[0],
        prospectFields: fileupload.data.prospectFields,
      };
      props.RebindHeader(obj, row);
    }
  };

  const ReProcess = async (row) => {
    let data = {
      fid: row._id,
    };
    await API_GET(`action/StartProcessingRecords?fid=${row._id}`);


  };
  const onDownload = async (row) => {
    let href = `//${REACT_APP_SERVER_URL}/downloads/downloadAWSFile?fid=${row._id}&endpoint=filesCollection`;

    window.open(href, "_blank")
  };
  const ViewHistory = async (row) => {
    let href = `/admin/ProspectHistory?fid=${row._id}`;

    window.open(href, "_self")
  };

  const getFileList = async () => {
    try {
      let con = { admin: user && user.admin, cid };

      let res = await API_GET(
        `action/getFilesList?page=${page}&per_page=${countPerPage}&delay=1`,
        null,
        {
          query: con,
        }
      );
      debugger;
      setData(res && res.data);
    }
    catch (e) {

    }
  };

  const updateFileCollection = async (element, Type) => {
    let registerRequest;
    let IsActiveFile = Type;

    registerRequest = await API_POST("action/upsert", {
      root: "filesCollection",
      body: { IsActiveFile },
      querydata: { admin: user.admin, _id: element._id },
    });
    if (registerRequest && registerRequest.status == 200) {
      getFileList();
    }
  };

  const handleAction = async (e, element, Type) => {
    let registerRequest;
    let IsActive = false;
    IsActive = Type == "Active" ? true : false;

    registerRequest = await API_POST("action/updateMany", {
      root: "prospects",
      body: { IsActive },
      querydata: { admin: user.admin, cid, fid: element._id },
    });
    if (registerRequest && registerRequest.status == 200) {

      updateFileCollection(element, IsActive);
    }
  };

  // Helper function to render Yes/No badges for boolean values
  const renderBooleanBadge = (value) => {
    if (value === true) {
      return <span style={{ backgroundColor: '#4caf50', color: 'white', padding: '3px 8px', borderRadius: '4px', fontSize: '12px' }}>Yes</span>;
    } else if (value === false) {
      return <span style={{ backgroundColor: '#f44336', color: 'white', padding: '3px 8px', borderRadius: '4px', fontSize: '12px' }}>No</span>;
    } else {
      return <span style={{ backgroundColor: '#9e9e9e', color: 'white', padding: '3px 8px', borderRadius: '4px', fontSize: '12px' }}>N/A</span>;
    }
  };

  const columns = [
    {
      name: "File Name",
      width: "200px",
      cell: (row) => (
        <span>{row.filename}</span>
      ),
    },
    {
      name: "Created On",
      width: "120px",
      cell: (row) => (
        <span>{dayjs(row.createdOn).format("DD/MM/YYYY hh:mm")}</span>
      ),
    },
    {
      name: "Total Records",
      //selector: "TotalRecordsInExcel",
      width: "100px",
      cell: (row) => (
        <span>{row.TotalRecordsInExcel}</span>
      ),
    },
    {
      name: "Inserted Records",
      //selector: "InsertedRecords",
      width: "100px",
      cell: (row) => (
        <span>{row.InsertedRecords}</span>
      ),
    },
    {
      name: "Updated Records",
      //selector: "UpdatedRecords",
      width: "100px",
      cell: (row) => (
        <span>{row.UpdatedRecords}</span>
      ),
    },
    {
      name: "Failed Records",
      //selector: "ErrorRecords",
      width: "100px",
      cell: (row) => (
        <span>{row.ErrorRecords}</span>
      ),
    },
    {
      name: "Import Options",
      width: "180px",
      cell: (row) => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ fontSize: '12px', fontWeight: '500', width: '100px' }}>Duplicate records:</span>
            {renderBooleanBadge(row.IsCheckedCampain)}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ fontSize: '12px', fontWeight: '500', width: '100px' }}>Make Fresh:</span>
            {renderBooleanBadge(row.IsCheckedMakeFresh)}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ fontSize: '12px', fontWeight: '500', width: '100px' }}>Low call priority:</span>
            {renderBooleanBadge(row.IsOpenUpdateProspect)}
          </div>
        </div>
      ),
      sortable: false,
    },
    
    {
      name: "Error Message",
      //selector: "errorMessage",
      width: "100px",
      cell: (row) => (
        <span>{row.errorMessage}</span>
      ),
    },
    {
      name: "Action",
      width: "220px",
      cell: (row) => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          {/* Action buttons with modern design */}
          {(row.IsExcelExport || row.IsFileUploaded) && (
            <div 
              onClick={(e) => { onDownload(row); }}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '6px 10px',
                borderRadius: '20px',
                backgroundColor: '#e3f2fd',
                border: '1px solid #90caf9',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              }}
              onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#bbdefb'; }}
              onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#e3f2fd'; }}
            >
              <GetAppOutlinedIcon style={{ color: '#1976d2', fontSize: '18px' }} />
              <span style={{ marginLeft: '8px', fontSize: '13px', color: '#1976d2', fontWeight: '500' }}>Download File</span>
            </div>
          )}

          {row.TotalRecordsInExcel > row.TotalRecords && (
            <div 
              onClick={(e) => { StartProcess(row); }}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '6px 10px',
                borderRadius: '20px',
                backgroundColor: '#fff3e0',
                border: '1px solid #ffcc80',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              }}
              onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#ffe0b2'; }}
              onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#fff3e0'; }}
            >
              <CompareArrowsIcon style={{ color: '#e65100', fontSize: '18px' }} />
              <span style={{ marginLeft: '8px', fontSize: '13px', color: '#e65100', fontWeight: '500' }}>Re-Map Fields</span>
            </div>
          )}
          
          {row.TotalRecordsInExcel > row.TotalRecords && (
            <div 
              onClick={(e) => { ReProcess(row); }}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '6px 10px',
                borderRadius: '20px',
                backgroundColor: '#e8f5e9',
                border: '1px solid #a5d6a7',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              }}
              onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#c8e6c9'; }}
              onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#e8f5e9'; }}
            >
              <AutorenewIcon style={{ color: '#2e7d32', fontSize: '18px' }} />
              <span style={{ marginLeft: '8px', fontSize: '13px', color: '#2e7d32', fontWeight: '500' }}>Process Records</span>
            </div>
          )}
          
          {row.TotalRecordsInExcel <= row.TotalRecords && (
            <div 
              onClick={(e) => { ViewHistory(row); }}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '6px 10px',
                borderRadius: '20px',
                backgroundColor: '#ede7f6',
                border: '1px solid #b39ddb',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              }}
              onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#d1c4e9'; }}
              onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#ede7f6'; }}
            >
              <ViewHeadlineIcon style={{ color: '#4527a0', fontSize: '18px' }} />
              <span style={{ marginLeft: '8px', fontSize: '13px', color: '#4527a0', fontWeight: '500' }}>View Prospects</span>
            </div>
          )}
        </div>
      ),
    },
    {
      name: "",
      cell: (row) => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          {!row.IsExcelExport && campaignsDetails && campaignsDetails.ActiveInactiveProspect && (
            <>
              {!row.IsActiveFile && (
                <Button
                  size="sm"
                  title="Filter"
                  color="primary"
                  onClick={(e) => {
                    handleAction(e, row, "Active");
                  }}
                >
                  Active
                </Button>
              )}

              {row.IsActiveFile && (
                <Button
                  size="sm"
                  title="Filter"
                  color="danger"
                  onClick={(e) => {
                    handleAction(e, row, "Inactive");
                  }}
                >
                  Deactive
                </Button>
              )}
            </>
          )}
        </div>
      ),
      width: "100px",
    },
  ];



  useEffect(() => {
    getFileList();
    const interval = setInterval(() => {
      console.log("auto reload")
      getFileList();
    }, 3000);

    return () => clearInterval(interval);

  }, [page]);

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <h3>File Logs
            <GridItem style={{ float: "right" }}>
              <InfoBox name={'SystemLogs.Files'} />
            </GridItem>
          </h3>
        </GridItem>
     
        <GridItem xs={12} sm={12} md={12}>
          {/* {JSON.stringify(data)} */}
          <DataTable
            columns={columns}
            data={data && data.data}
            paginationTotalRows={data && data.total}
            paginationPerPage={countPerPage}
            highlightOnHover
            pagination
            paginationServer
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            onChangePage={(page) => setPage(page)}
          />
        </GridItem>
      </GridContainer>

    </>
  );
}

export default FilesList;
